module.exports = {
  adverseTerms:  (Api) ->
    return Api.AdverseTerms.query().$promise
  languages: (Api) ->
    return Api.Language.query().$promise
}
